// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loader_spinnerContainer__1gcT2","spinner":"Loader_spinner__1S3SZ","spinnerContainerTransparent":"Loader_spinnerContainerTransparent__1F4sr"};